import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { setError } from 'slices/clientSubUserSlice';
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { Controller, useForm } from 'react-hook-form';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { styled } from '@mui/material';
import { Dialog, DialogTitle } from '@mui/material';
import { clientSubUserSelector } from 'slices/clientSubUserSlice';
import { updateClientSubUsers } from 'slices/clientSubUserSlice';
import { addClientSubUsers } from 'slices/clientSubUserSlice';
import { fetchClientSubUsers } from 'slices/clientSubUserSlice';
import {
  adminClientSubUserSelector,
  addAdminClientSubUsers,
  updateAdminClientSubUsers,
  fetchAdminClientSubUsers,
  setError as setAdminError,
} from 'slices/adminClientSubUserSlice';
// `adminClientId` (a subclient_types.id) is passed when an admin manages a
// specific client's sub users; when absent, this behaves as the client-portal
// self-service form. All admin/client branching keys off that single prop.
const ClientSubUsersForm = ({ item, handleClose, callback, show, adminClientId }) => {
  const dispatch = useDispatch();
  const { getValues, handleSubmit, watch, formState: { errors }, control, setValue, clearErrors } = useForm();
  const [status, setStatus] = useState(1)
  const clientState = useSelector(clientSubUserSelector);
  const adminState = useSelector(adminClientSubUserSelector);
  const { error, loader } = adminClientId ? adminState : clientState;
  const resetErrors = () => dispatch(adminClientId ? setAdminError({}) : setError({}));
  const refetchList = () => dispatch(adminClientId ? fetchAdminClientSubUsers(adminClientId) : fetchClientSubUsers());
  const clearAll = () => {
    setValue("name", '');
    setValue("group_id", '');
    setValue('email', '');
    setValue('password', '');
    setStatus(1)
    resetErrors()
  }
  const getCleanRole = (role) => {
    return role?.startsWith("staff_") ? role.replace("staff_", "") : role;
  };
  useEffect(() => {
    setValue('name', item?.user?.name || '');
    setValue('group_id', item?.group?.id || '');
    setValue('email', item?.user?.email || '');
    setStatus((typeof (item?.status) == "number") ? item?.status : 1)
  }, [item]);

  useEffect(() => {
    return () => clearAll()
  }, [show])

  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      refetchList()
      handleClose()
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    resetErrors()
    data = {
      ...data,
      status,
    };
    if (item?.id) {
      dispatch(adminClientId
        ? updateAdminClientSubUsers(adminClientId, data, item?.id, submitCallback)
        : updateClientSubUsers(data, item?.id, submitCallback));
    } else {
      dispatch(adminClientId
        ? addAdminClientSubUsers(adminClientId, data, submitCallback)
        : addClientSubUsers(data, submitCallback));
    }
  }

  // #region Language dropdown
  const [groupSelect, setGroupSelect] = useState(null)

  useEffect(() => {
    setGroupSelect({
      label: item?.group?.name || "",
      value: item?.group?.id || ""
    });
  }, [item?.group]);

  //#endregion

  const onError = (errors) => {
    console.log("errors", errors)

  }
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit, onError)}>

        <div className="row-primary">
          <h2>Sub User Name *</h2>
          <Controller
            name="name"
            rules={{
              required: "Please enter name"
            }}
            control={control}
            render={({ field }) =>
              <div className='w-100'>
                <input className="input-in type_inp" type="text" name='name' placeholder='Sub user name' {...field} />
                {errors?.name?.message && <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.name?.message} />
                </div>}
              </div>
            }
          />
        </div>

        {/* <div className="row-primary">
          <h2>Permission Group *</h2>
          <Controller
            name="group_id"
            required
            rules={{
              required: "Please select a group",
            }}
            control={control}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <AsyncPaginate
                    menuPlacement='auto'
                    styles={{
                      ...selectCustomStyles,
                    }}
                    value={groupSelect || null}
                    loadOptions={filterPermissionGroup}
                    isClearable
                    escapeClearsValue
                    onChange={(selected) => {
                      setGroupSelect(selected);
                      field.onChange(selected ? selected.value : null);
                    }}

                    additional={{
                      page: 1,
                    }}
                  />
                </div>
                {errors?.group_id?.message && <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.group_id?.message} />
                </div>}
              </div>
            }
          />
        </div> */}

        <div className="row-primary">
          <h2>Email *</h2>
          <Controller
            name="email"
            rules={{
              required: 'Email field is required'
            }}
            control={control}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <input className="input-in type_inp" type="email" name='email' placeholder='Email address' {...field} />
                {errors?.email?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.email?.message} />
                  </div>
                )}
                {
                  error?.errors?.email?.length > 0 &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={error?.errors?.email?.[0]} />
                  </div>
                }
              </div>
            )
            }
          />
        </div>

        <div className="row-primary">
          <h2>Password {item?.id ? '' : '*'}</h2>
          <div className="w-100">
            <Controller
              name="password"
              control={control}
              rules={
                item?.id ? {} :{
                  required: "Password required",
                } 
              }
              render={({ field }) => (
                <input
                  className="input-in type_inp"
                  type="password"
                  placeholder="Password"
                  {...field}
                />
              )}
            />
            {errors?.password?.message && (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.password?.message} />
              </div>
            )}
          </div>
        </div>


        <div className="row-primary align-items-ceneter">
          <h2 className='mt-0'>Status</h2>
          <CustomSwitch
            labelText="active"
            checked={status == 1 ? true : false}
            handleChange={(checked) => setStatus(checked ? 1 : 0)}
          />
        </div>

        {error?.errors?.name?.map((error) => (
          <div style={{ marginBottom: 10 }}>
            <ErrorMessage text={error} />
          </div>
        ))}

        <div className="Form-footer">
          <button type="button" className="Cancle_button" onClick={handleClose} >Cancel</button>
          <SubmitButton
            btnText={item?.id ? "Update" : "Create"}
            loader={loader}
          />
        </div>
      </form>

    </div>
  )
}

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-container': {
    overflowY: "auto",
    margin: "auto",
    alignItems: "flex-start",
  },
  '& .MuiPaper-root': {
    maxHeight: "none",
    overflowY: "hidden",
    borderRadius: 20
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
    backgroundColor: "red"
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
    backgroundColor: "red"
  },
}));

const AddClientSubUsers = ({ item, onClose, callback, show, adminClientId }) => {

  return (
    <>

      <BootstrapDialog
        fullWidth={true}
        maxWidth={"md"}
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={show}
        sx={{
          '& .MuiDialog-container': {
            alignItems: "center",
          },
          '& .MuiPaper-root': {
            overflowY: "visible",

          },
        }}
      >
        <div className="">
          <div className="modal-content full_modal">
            <DialogTitle>
              <div className="modal-header header_modal align-items-center">
                <div></div>
                <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Sub Users</h5>
                <button type="button" className="btn-close"
                  aria-label="Close"
                  onClick={
                    () => {
                      onClose(item?.id, item?.status);
                    }
                  }></button>
              </div>
            </DialogTitle>
            <div className="modal-body modal_form_body">
              <ClientSubUsersForm item={item} handleClose={onClose} callback={callback} show={show} adminClientId={adminClientId} />
            </div>
          </div>
        </div>
      </BootstrapDialog>
    </>
  )
}

export default AddClientSubUsers
